<template>
  <div class="filter-container" ref="filtroRef">
    <ThemedIcon name="close" class="modal-close" @click="closeModal" />
    <div class="close-mobile">
      <svg
        class="closer"
        @click="closeModal"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="4"
        viewBox="0 0 24 4"
        fill="none"
      >
        <path
          d="M2 2H22"
          stroke="#CDCDCD"
          stroke-width="3"
          stroke-linecap="round"
        />
      </svg>
    </div>

    <div class="modal-header">
      <div class="titleContainer">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M19.6935 17.9925L15.1596 13.4586C16.2511 12.0054 16.8404 10.2367 16.8384 8.4192C16.8384 3.77688 13.0615 0 8.4192 0C3.77688 0 0 3.77688 0 8.4192C0 13.0615 3.77688 16.8384 8.4192 16.8384C10.2367 16.8404 12.0054 16.2511 13.4586 15.1596L17.9925 19.6935C18.222 19.8986 18.5213 20.0081 18.829 19.9995C19.1367 19.9909 19.4295 19.8648 19.6472 19.6472C19.8648 19.4295 19.9909 19.1367 19.9995 18.829C20.0081 18.5213 19.8986 18.222 19.6935 17.9925ZM2.40549 8.4192C2.40549 7.2298 2.75818 6.06711 3.41898 5.07816C4.07977 4.08921 5.01899 3.31842 6.11785 2.86325C7.21671 2.40809 8.42587 2.289 9.59242 2.52104C10.759 2.75308 11.8305 3.32583 12.6715 4.16686C13.5126 5.00789 14.0853 6.07944 14.3174 7.24598C14.5494 8.41253 14.4303 9.62169 13.9751 10.7205C13.52 11.8194 12.7492 12.7586 11.7602 13.4194C10.7713 14.0802 9.6086 14.4329 8.4192 14.4329C6.82485 14.431 5.29635 13.7968 4.16897 12.6694C3.0416 11.5421 2.4074 10.0135 2.40549 8.4192Z"
            fill="#00C3A8"
          />
        </svg>
        <h1 class="h1-heroMuni">Filtro de {{ seccionActual.title }}</h1>
      </div>
    </div>

    <div class="modal-body">
      <div class="filter-content">
        <div class="tabs">
          <button
            v-for="tab in tabs"
            :key="tab.title"
            class="tab-button"
            :class="[
              'tab-button',
              {
                active: seccionActual.name === tab.name,
                'h2-heroMuni': seccionActual.name === tab.name,
                'h2-defaultMuni': seccionActual.name !== tab.name,
              },
            ]"
            @click="changeTab(tab)"
          >
            {{ tab.title }}
          </button>
        </div>

        <div class="selects">
          <FilterTramites
            v-if="seccionActual.title === 'Trámites'"
            :areas="areas"
            :munis="munis"
            :channels="channels"
            @close-modal="closeModal"
          />

          <FilterTurnos
            v-else-if="seccionActual.title === 'Turnos'"
            :areas="areas"
            @close-modal="closeModal"
          />

          <FilterTareas
            v-else-if="seccionActual.title === 'Tareas'"
            :munis="munis"
            @close-modal="closeModal"
          />

          <FilterVecinos
            v-else-if="seccionActual.title === 'Vecinos'"
            @close-modal="closeModal"
          />
        </div>
      </div>
    </div>

    <div class="modal-footer"></div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";
// import { useRoute, useRouter } from "vue-router";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

// Servicios
import AreaService from "@/services/office/areaService";
import ProceduresService from "@/services/office/proceduresService";
import UserMuniService from "@/services/office/userMuniService";

// Importar los nuevos componentes
import FilterTramites from "./Filters/FilterTramites.vue";
import FilterTareas from "./Filters/FilterTareas.vue";
import FilterTurnos from "./Filters/FilterTurnos.vue";
import FilterVecinos from "./Filters/FilterVecinos.vue";
import ThemedIcon from "@/components/Utils/ThemedIcon.vue";

// const emit = defineEmits(["close-modal", "filtro-aplicado", "filtro-limpiado"]);
const emit = defineEmits(["close-modal"]);
const route = useRoute();
// const router = useRouter();
const store = useStore();

const requireContext = require.context(
  "@/assets/images/muni/canales/",
  false,
  /\.svg$/,
);
const channelIcons = requireContext.keys().map(requireContext);

const tabs = [
  { title: "Trámites", name: "home-agentes" },
  { title: "Turnos", name: "turnero" },
  { title: "Tareas", name: "tareas" },
  { title: "Vecinos", name: "vecinos" },
];

const seccionActual = ref({ title: "Trámites", name: "home-agentes" });
const areas = ref([]);
const munis = ref([]);
const channels = ref([]);

// --- CARGA DE DATOS COMUNES ---
const fetchMunicipals = async () => {
  const response = await UserMuniService.getAll();
  if (!response?.success) return;
  munis.value = response.data?.Munis?.sort((a, b) =>
    a.firstname?.localeCompare(b.firstname ?? ""),
  );
};

const fetchAreas = async () => {
  const response = await AreaService.getAll();
  if (!response?.success) return;
  areas.value = response.data.Areas.map((area) => ({
    ...area,
    area_name: formatString(area.area_name),
  }));
  if (store.state?.user?.role !== "ADMIN_ROLE") {
    areas.value = areas.value?.filter((a) =>
      store.state.user?.muniAreas?.some((am) => am.area?.id === a.id),
    );
  }
};

const fetchChannels = async () => {
  const response = await ProceduresService.getChannels();
  if (!response?.success) return;
  const channelsData =
    Object.keys(response.data)?.map((key) => response.data[key]) ?? [];
  channels.value = channelsData.map((channel) => ({
    value: channel,
    image: channelIcons.find((ch) =>
      normalizeString(ch.toLowerCase()).includes(
        normalizeString(channel.toLowerCase()),
      ),
    ),
  }));
};

// --- HELPERS ---
const normalizeString = (str) =>
  str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
const formatString = (option) => {
  if (!option) return "";
  return option
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

const getSeccionTitle = (path) => {
  if (path.includes("vecinos")) return "Vecinos";
  if (path.includes("tareas")) return "Tareas";
  if (path.includes("turnero")) return "Turnos";
  return "Trámites";
};

// --- LOGICA UI ---
const closeModal = () => emit("close-modal");

const changeTab = (tab) => {
  seccionActual.value = tab;
  // Opcional: Si quieres que cambiar pestaña navegue
  // if (route.name !== tab.name) router.push({ name: tab.name });
};

// Watch para sincronizar la pestaña con la URL
watch(
  () => route.path,
  (newPath) => {
    const title = getSeccionTitle(newPath.toLowerCase());
    const found = tabs.find((tab) => tab.title === title);
    if (found) seccionActual.value = found;
  },
  { immediate: true },
);

onMounted(() => {
  fetchMunicipals();
  fetchChannels();
  fetchAreas();
});

defineExpose({ widthDesktop: 39.824 });
</script>

<style scoped>
/* ESTILOS GLOBALES DEL MODAL Y LAYOUT */
.filter-container {
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  position: relative;
  background-color: var(--gray);

  --pe-option-padding: 0px;
  --pe-dropdown-item-min-height: 5px;
  --pe-dropdown-l-scrollbar-witdh: none;
  --pe-scrollbar-thumb: transparent;
}

.modal-body {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow-y: auto;
  min-height: 0;
}

.filter-content {
  display: flex;
  flex-direction: column;
  /* Mobile first */
  height: 100%;
}

/* TABS */
.tabs {
  display: none;
  /* Oculto en mobile */
}

/* =========================================================
   ESTILOS COMPARTIDOS (Usando :deep para afectar hijos)
   ========================================================= */

/* Estilos de inputs y wrappers dentro de los componentes hijos */
:deep(.formulario) {
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
}

:deep(.input-wrapper) {
  position: relative;
  width: 100%;
}

:deep(.clear-button) {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 1.25rem;
  line-height: 1;
  color: var(--gray-dark);
}

:deep(.h2-defaultMuni .inputMuniV2) {
  height: auto;
  font-size: inherit;
  line-height: inherit;
  font-family: inherit;
  font-weight: inherit;
  color: inherit;
}

:deep(.ListContainer) {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 5px;
}

:deep(.ListItem) {
  display: flex;
  border: none;
  background: var(--bg-popup);
  border-radius: 0.62581rem;
  padding: 10px;
  cursor: pointer;
  align-items: center;
  gap: 0.74vw;
  width: fit-content;
}

:deep(.status-item-container) {
  padding-left: 0.62rem;
  display: flex;
  align-items: center;
  gap: 10px;
}

:deep(.status-circle) {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

/* Contenedor de inputs dentro del orquestador */
.selects {
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  /* Mobile fill */
}

.btnsSection {
  /* Esto se moverá con deep en desktop */
}

:deep(.btnsSection) {
  display: flex;
  flex-direction: row;
  gap: 1rem;
  padding: 1.5rem 0 0 0;
  flex-shrink: 0;
}

:deep(.actionBtn) {
  width: 100%;
  padding: 0.96vh;
  color: var(--blanco);
  border: none;
  transition: all 0.2s ease;
  border-radius: 0.625rem;
  cursor: pointer;
}

:deep(.pe-dropdown-list) {
  background: var(--gray) !important;
}

:deep(.pe-dropdown-item.pe-dropdown-item--highlighted) {
  color: var(--text-primary) !important;
}

[theme="dark"] .pe-dropdown-item.pe-dropdown-item--highlighted {
  color: var(--text-inverse) !important;
}

[theme="light"] .pe-dropdown-item.pe-dropdown-item--highlighted {
  color: var(--text-primary) !important;
}

:deep(.pe-dropdown-item) {
  color: var(--text-primary) !important;
}

/* -------------------------------------------------------------------------- */
/* ESTILOS MOBILE (max-width: 768px)                                          */
/* -------------------------------------------------------------------------- */
@media (max-width: 768px) {
  .filter-container {
    height: auto;
    width: 100vw;
    background-color: inherit;
  }

  .modal-body {
    padding: 0 1rem;
    scrollbar-width: none;
  }

  .modal-body::-webkit-scrollbar {
    display: none;
  }

  .modal-header {
    padding: 0rem 1.5rem 1.5rem 1.5rem;
    flex-shrink: 0;
  }

  .titleContainer {
    display: flex;
    align-items: center;
    gap: 2.22vw;
    justify-content: flex-start;
    color: var(--text-primary);
  }

  .close-mobile {
    /* position: absolute; */
    top: 0;
    left: 0;
    width: 100%;
    z-index: 20;
    height: 30px;
    display: flex;
    justify-content: center;
    visibility: visible;
  }

  .closer {
    width: 38px;
    height: 30px !important;
  }

  .modal-close {
    display: none;
  }

  :deep(.btnsSection) {
    padding: 1.5rem 0;
  }
  :deep(.actionBtn) {
    width: 100%;
    padding: 0.96vh;
    height: 40px;
  }

  /* Inputs Mobile */
  :deep(.inputMuniV2),
  :deep(.formulario input),
  :deep(.input-wrapper input),
  select {
    height: 4.49vh;
    min-height: 30px;
    padding: 1.02vh 5.56vw;
    padding-right: 8.33vw;
    border-radius: 0.751rem;
    border: none;
    outline: none;
    background: var(--border);
    width: 100%;
    color: var(--text-primary);
    font-weight: 500;
  }

  :deep(.inputMuniV2::placeholder),
  :deep(.formulario input::placeholder),
  :deep(.input-wrapper input::placeholder),
  select {
    color: var(--text-primary);
    font-weight: 500;
  }

  :deep(.h2-defaultMuni .datepicker-container .display-input) {
    height: 4.49vh;
    min-height: 30px;
    border-radius: 0.751rem;
    padding: 1.02vh 5.56vw;
    background: var(--border);
  }

  :deep(.dropdown-list) {
    margin-top: -4px;
    border-radius: 0px 0px 0.751rem 0.751rem;
    background: var(--border);
    box-shadow: none;
  }

  :deep(.listElement) {
    background-color: transparent;
  }

  :deep(.formulario) {
    gap: 3.84vh;
  }

  /* Animaciones */
  @keyframes slideUp {
    from {
      transform: translateY(100%) translateX(-50%);
      opacity: 0;
    }

    to {
      transform: translateY(0) translateX(-50%);
      opacity: 1;
    }
  }

  @keyframes slideDown {
    from {
      transform: translateY(0) translateX(-50%);
      opacity: 1;
    }

    to {
      transform: translateY(100%) translateX(-50%);
      opacity: 0;
    }
  }

  :global(.modal-container:has(.filter-container).opening) {
    animation: slideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards;
    opacity: 0;
  }

  :global(.modal-container:has(.filter-container).closing) {
    animation: slideDown 0.3s cubic-bezier(0.7, 0, 0.84, 0) forwards;
    pointer-events: none !important;
  }
}

/* -------------------------------------------------------------------------- */
/* ESTILOS DESKTOP (min-width: 769px)                                         */
/* -------------------------------------------------------------------------- */
@media (min-width: 769px) {
  .modal-header,
  .modal-footer,
  .modal-close,
  .close-mobile {
    display: none;
  }

  .filter-container {
    width: 39.824vw;
    min-height: 57.66vh;
    height: auto;
    padding: 1.46vw;
    overflow: visible;
    background: var(--gray-version);
  }

  .modal-body {
    padding: 0;
    overflow: visible;
  }

  .filter-content {
    flex-direction: row;
    gap: 1.46vw;
    flex: 1 1 auto;
  }

  /* TABS DESKTOP */
  .tabs {
    display: flex;
    flex-direction: column;
    gap: 0.83vh;
  }

  .tab-button {
    padding: 0.625rem 0.313rem;
    height: 6.59vh;
    width: 10.249vw;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    border: none;
    border-bottom: 1px solid var(--text-muted);
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.2s ease;
  }

  .tab-button.active {
    background: rgba(0, 195, 168, 0.2);
    color: var(--text-primary);
    border-bottom: 1px solid var(--gris-claro);
  }

  .tab-button:hover:not(.active) {
    background-color: rgba(0, 195, 168, 0.12);
  }

  /* SELECTS DESKTOP */
  .selects {
    max-width: 25.256vw;
    justify-content: flex-start;
  }

  :deep(.inputMuniV2),
  :deep(.formulario input),
  :deep(.input-wrapper input),
  select {
    background: var(--backgroundPlaceholder);
    width: 100%;
    max-width: 25.256vw;
    height: 6.59vh;
    padding: 10px;
    align-items: center;
    border-radius: 8px;
    padding-right: 30px;
    border: none;
    outline: none;
    color: var(--text-primary);
  }

  :deep(input::placeholder) {
    color: var(--text-primary);
    opacity: 1;
    /* importante para que no se vea lavado */
  }

  :deep(.btnsSection) {
    display: flex;
    flex-direction: row;
    gap: 1.83vw;
    justify-content: center;
    margin-top: auto;
    padding-top: 1rem;
  }

  :deep(.actionBtn) {
    display: flex;
    width: 8.053vw;
    padding: 0.82vh 4.85vh;
    border-radius: 0.625rem;
    justify-content: center;
    border-bottom: none;
    color: var(--blanco);
  }

  [theme="dark"] .pe-dropdown-item.pe-dropdown-item--highlighted {
    color: var(--text-inverse) !important;
  }

  [theme="light"] .pe-dropdown-item.pe-dropdown-item--highlighted {
    color: var(--text-primary) !important;
  }
}

/* LISTAS Y ELEMENTOS */
:deep(.status-item-container.selected) {
  padding-left: unset;
  padding: unset;
  height: 6.59vh;
}

:deep(.dropdown-list) {
  margin-top: 5px;
  background-color: var(--bg-popup);
}

:deep(.status-item-container) {
  /* :deep(.listElement) { */
  background-color: transparent;
  padding: 0.5rem 1rem;
  margin: 0rem 0.62rem;
  border-bottom: 1px solid var(--text-muted);
  width: 100%;
  /* color: var(--text-inverse) !important; */
}

:deep(.h3-heroMuni) {
  color: unset;
}

:deep(li:last-child .status-item-container) {
  border-bottom: none;
}

:global(.modal-container:has(.filter-container)) {
  border-radius: 0.5rem !important;
}

:deep(.pe-dropdown-item--info) {
  min-height: 4vh !important;
  color: var(--text-primary);
}
</style>

<style>
.pe-dropdown-item.pe-dropdown-item--highlighted {
  color: var(--text-primary);
}

[data-theme="dark"] .pe-dropdown-item.pe-dropdown-item--highlighted {
  color: var(--text-inverse) !important;
}
</style>
